import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from './core/services/shared-service/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ResetSearchGuard implements CanActivate {
  constructor(private notesService: SharedService,) {}

  canActivate(): boolean | Observable<boolean> {
    this.notesService.clearHeaderValue();
    // this.notesService.setHeaderValue(null); // Call the reset logic
    return true; // Allow the route change
  }
  
}
